export default __webpack_public_path__ + "da4b799426e8dcaf14863348e08e13f5.svg";